var _ellipse, _ellipse2, _path, _g, _rect, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharepointDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.4453,
    cy: 30.8571,
    rx: 20.0391,
    ry: 20.3571,
    fill: "url(#paint0_linear_504_11629)",
    stroke: "none"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.375,
    cy: 42.6428,
    rx: 16.875,
    ry: 17.1428,
    fill: "url(#paint1_linear_504_11629)",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_504_11629",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 19,
    width: 29,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2656 56.5715C55.2656 64.264 49.127 70.5 41.5547 70.5C33.9823 70.5 27.8438 64.264 27.8438 56.5715C27.8438 48.879 27.8438 19.0715 27.8438 19.0715H55.2656C55.2656 19.0715 55.2656 51.6403 55.2656 56.5715Z",
    fill: "#C4C4C4",
    stroke: "none"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_504_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.5547,
    cy: 56.5714,
    rx: 13.7109,
    ry: 13.9286,
    fill: "url(#paint2_linear_504_11629)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5156 28.5C21.5156 26.8431 22.8588 25.5 24.5156 25.5H45.9375C47.5944 25.5 48.9375 26.8431 48.9375 28.5V61.0714C48.9375 62.7283 47.5944 64.0714 45.9375 64.0714H21.5156V28.5Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "none"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 21.2143,
    width: 37.9688,
    height: 38.5714,
    rx: 2,
    fill: "url(#paint3_linear_504_11629)",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1719 45.0491C34.1719 41.7271 31.9785 40.2606 27.4148 38.5547C23.8417 37.2079 22.9926 36.8189 22.9926 35.532C22.9926 34.4246 24.054 33.6764 25.8582 33.6764C27.6978 33.6764 29.4313 34.3049 31.3771 35.3823L33.3582 31.8209C31.2709 30.504 28.7945 29.7858 25.7874 29.7858C21.1884 29.7858 17.8983 32.18 17.8983 35.8313C17.8983 39.5723 20.5162 40.7694 24.903 42.3556C28.4054 43.6126 29.0775 44.2411 29.0775 45.3484C29.0775 46.6652 27.8393 47.3237 25.8936 47.3237C23.594 47.3237 21.5775 46.5156 19.561 45.1988L17.2969 48.6106C19.7733 50.3464 22.8511 51.2143 25.9997 51.2143C30.7403 51.2143 34.1719 48.9398 34.1719 45.0491Z",
    fill: "white",
    stroke: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_504_11629",
    x1: 19.4062,
    y1: 30.8571,
    x2: 62.8242,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#116B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_504_11629",
    x1: 44.7188,
    y1: 34.0714,
    x2: 74.4771,
    y2: 50.8105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D9097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29BBC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_504_11629",
    x1: 32.0625,
    y1: 52.2857,
    x2: 55.3895,
    y2: 62.7232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31D6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_504_11629",
    x1: 6.75,
    y1: 40.5,
    x2: 47.8828,
    y2: 40.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#105557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#116B6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepointDark);
export default __webpack_public_path__ + "static/media/sharepoint-dark.4b8d3a33a2cc1123fc12a461d9e2933c.svg";
export { ForwardRef as ReactComponent };